import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import DiffChecker from 'ravenjs/components/DiffChecker';
import { get } from 'ravenjs/utils/lodash';

import { MODALS } from 'constants/modals';
import { selectors as uiSelectors } from 'modules/ui';
import Modal from '../Modal';

function DiffCheckerModal(props) {
    const { modal } = props;

    const actions = get(modal, 'data.actions', []);
    const diffCheckerProps = get(modal, 'data.diffCheckerProps', {
        changedLabel: 'Changed',
        changedText: 'I am the changed text!',
        diffs: [],
        originalLabel: 'Original',
        originalText: 'I am the original text.',
    });

    const renderContent = () => <DiffChecker {...diffCheckerProps} />;

    return (
        <Modal
            actions={actions}
            content={renderContent()}
            id={MODALS.DIFF_CHECKER}
            open={get(modal, 'open', false)}
        />
    );
}

DiffCheckerModal.propTypes = {
    modal: object.isRequired,
};

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.DIFF_CHECKER),
});

export default connect(mapStateToProps, null)(DiffCheckerModal);
